import { MetaData } from "../components/MetaData";
import { GalleryItem } from "../components/GalleryItem";
import { AdditionalInfo } from "./AdditionalInfo";

export function Project({
  id,
  thumbnailUrl,
  disciplines,
  shortDisciplines,
  year,
  project,
  additionalInfo,
  description = "",
  credits = [],
  galleryItems = [],
}) {
  return (
    <div className="project">
      <header className="project-hero grid-twelve-cols-lg grid-four-cols-sm">
        <img
          className="thumbnail square-media-one-by-one start-one-sm span-four-sm start-six-md span-three-md start-six-lg span-two-lg"
          src={thumbnailUrl}
          alt={`Thumbnail for ${project}`}
        />
        <MetaData
          disciplines={disciplines}
          shortDisciplines={shortDisciplines}
          year={year}
          project={project}
        />
        {additionalInfo && (
          <AdditionalInfo
            awards={additionalInfo.awards}
            exhibitions={additionalInfo.exhibitions}
            publications={additionalInfo.publications}
          />
        )}

        <div className="description grid-twelve-cols-lg grid-four-cols-sm span-four-sm span-twelve-lg">
          {description && (
            <p className="span-twelve-lg start-one-lg span-four-sm start-one-sm break-text">
              {description}
            </p>
          )}
          {credits && (
            <p className="start-two-lg span-eleven-lg start-one-sm span-four-sm">
              {credits[0]}
              <br />
              {credits[1]}
            </p>
          )}
        </div>
      </header>

      {galleryItems.map((item, i) => (
        <GalleryItem key={i} {...item} />
      ))}
    </div>
  );
}
